import { ComponentDescriptor, PageLayout } from '@kizi/comparator-core';
import addressWithWizardContext from '../widgets/Address/addressWithWizardContext';
import details from '../widgets/StartDetails/details';

const submitCurrentStep = {
  type: 'FormSubmit',
  props: {
    children: 'Vergelijk pakketten',
    variant: 'primary',
  },
};

const widgetLayout: 'horizontal' | 'horizontal-padded' | 'vertical' | string =
  'horizontal-padded';

let children: ComponentDescriptor[] = [];
if (widgetLayout === 'horizontal-padded') {
  children = [
    addressWithWizardContext,
    details[0],
    {
      type: 'Div',
      props: {
        variant: 'widget',
      },
      _children: [details[1], submitCurrentStep],
    },
  ];
} else {
  children = [
    addressWithWizardContext,
    details[0],
    details[1],
    submitCurrentStep,
  ];
}

const startWidgetLayout: PageLayout = {
  name: 'startWidget',
  components: [
    {
      type: 'StartWidget',
      props: {
        direction: widgetLayout === 'vertical' ? 'vertical' : 'horizontal',
        isPadded: widgetLayout === 'horizontal-padded',
        title: 'Internet en TV vergelijken',
        buttonProps: {
          children: 'Vergelijk pakketten',
        },
        nextStepIndex: 1,
        nextStepName: 'startWidget',
        fieldNames: [
          'startWidget.postcode',
          'startWidget.housenumber',
          'startWidget.housenumberaddition',
          'startWidget.houseNumberWithAddition',
          'startWidget.city',
          'startWidget.street',
          'startWidget.fullAddress',
          'startWidget.productTypes',
          'startWidget.isMove',
          'startWidget.currentProvider',
          'overview.filters',
          'overview.defaultFilters',
          'overview.defaultFilters',
          'overview.filterGraphQL',
        ],
      },
      _children: [...children],
    },
  ],
};

export default startWidgetLayout;
